import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { authApi } from './auth';
import { FAVOURITE_TASK, SUPPORT_STAFF_LIST, TASK_PLAN_LIST } from 'config/apiPaths';

export const supportStaffApi = createApi({
    reducerPath: 'supportStaffApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/support-staff",
    }),
    tagTypes: ["SupportStaff"],
    endpoints: (builder) => ({
        getSupportStaffList: builder.query({
            query: ({ page = 1, limit = 10, status = "", school = "", search = "", grade = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: SUPPORT_STAFF_LIST,
                data: { page, limit, sort, search, status: status?.value, school: school?.value, grade: grade?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),
        getTaskPlanList: builder.query({
            query: ({ page = 1, limit = 10, status = "", school = "", search = "", id = '', sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${TASK_PLAN_LIST}/${id}`,
                data: { page, limit, sort, search, status: status?.value, school: school?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TasksPlanList"]
        }),
        getSingleTaskPlan: builder.query({
            query: ({ id, clientId }) => ({
                method: "GET",
                url: `/task_plan_detail/${id}/${clientId}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),
        getTaskPlanSessionsData: builder.query({
            query: ({ taskPlanId, taskId, clientId }) => ({
                method: "GET",
                url: `/sessions/list/${taskPlanId}/${taskId}/${clientId}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlan"]
        }),
        favouriteTaskPlan: builder.mutation({
            query: ({ data, id }) => ({
                method: "POST",
                url: `${FAVOURITE_TASK}/${id}`,
                data: data
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TasksPlanList"]
        }),
    }),
})

export const {
    useGetTaskPlanListQuery,
    useGetSingleTaskPlanQuery,
    useGetSupportStaffListQuery,
    useGetTaskPlanSessionsDataQuery,
    useFavouriteTaskPlanMutation,
} = supportStaffApi;